import React from 'react';
import { Home, Search, PlusSquare, Bell, User } from 'lucide-react';

const BottomNav = ({ active, onChange, t, isRTL, unreadCount = 0 }) => {
  const items = [
    { key: 'feed', label: t('home'), Icon: Home, testid: 'nav-home' },
    { key: 'explore', label: t('explore'), Icon: Search, testid: 'nav-explore' },
    { key: 'create', label: t('createPost'), Icon: PlusSquare, testid: 'nav-create' },
    {
      key: 'notifications',
      label: t('notifications'),
      Icon: Bell,
      testid: 'nav-notifications',
      badge: unreadCount,
    },
    { key: 'profile', label: t('profile'), Icon: User, testid: 'nav-profile' },
  ];

  return (
    <nav
      data-testid="bottom-nav"
      dir={isRTL ? 'rtl' : 'ltr'}
      className="fixed bottom-0 inset-x-0 bg-white border-t border-gray-200 z-40"
    >
      <ul className="max-w-2xl mx-auto grid grid-cols-5">
        {items.map(({ key, label, Icon, testid, badge }) => {
          const isActive = active === key;
          return (
            <li key={key}>
              <button
                type="button"
                onClick={() => onChange(key)}
                data-testid={testid}
                className={`relative w-full flex flex-col items-center justify-center gap-1 py-2.5 text-xs transition-colors ${
                  isActive ? 'text-purple-600' : 'text-gray-500 hover:text-gray-700'
                }`}
              >
                <span className="relative">
                  <Icon className={`w-6 h-6 ${isActive ? 'stroke-[2.4]' : ''}`} />
                  {badge > 0 && (
                    <span
                      data-testid={`${testid}-badge`}
                      className="absolute -top-1 -end-2 min-w-[16px] h-4 px-1 rounded-full bg-red-500 text-white text-[10px] font-bold flex items-center justify-center leading-none"
                    >
                      {badge > 99 ? '99+' : badge}
                    </span>
                  )}
                </span>
                <span className="truncate">{label}</span>
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default BottomNav;
